module.exports = __webpack_public_path__ + "static/media/stop-the-cavity-monster_yeah.cdbaca8.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/stop-the-cavity-monster_yeah.mp3
// module id = FNp3
// module chunks = 0